<template>
    <div class="row">
        <transition name="slide-left">
            <div v-if="showSideMenu" class="position-absolute bg-white pl-3 w-100 side-menu-mobile">
                <help-center-side-menu :side-menu-items="parsed.menuCategories">
                </help-center-side-menu>
            </div>
        </transition>
        <div class="col-md-2 d-none d-md-block pl-0">
            <help-center-side-menu :side-menu-items="parsed.menuCategories">
            </help-center-side-menu>
        </div>
        <div class="col-12 col-md-10">
            <div class="row mt-3 p-sm-3" v-cloak>
                <h3 class="text-uppercase">Help Center</h3>
            </div>
            <hr class="accountsettings-bar mb-3" />

            <div v-for="c in parsed.categories" class="mb-5">
                <h3
                    class="text-uppercase font-weight-bold my-3"
                    :id="c.name.replace(/\s+/g, '').toLowerCase()"
                >
                    <a :href="'#' || `/help/category/${c.id}`">{{ c.name }}</a>
                </h3>
                <div v-for="a in c.help_article" class="card my-3">
                    <div class="card-body">
                        <div
                            @click="$set(a, 'display', true)"
                            class="card-title font-weight-bold"
                            style="font-size:1.5rem;"
                            :id="a.id"
                        >
                            {{ a.title }}
                        </div>
                        <div v-html="a.body" class="help-article"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpCenterSideMenu from "./help-center/HelpCenterSideMenu";

import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "HelpCenter",
    props: ["categories", "articles", "category_id", "article_id", "featured"],
    mixins: [sideMenuItems],
    components: {
        HelpCenterSideMenu,
    },
    data() {
        return {
            parsed: {
                categories: null,
                articles: null,
                featured: null,
            },
        };
    },
    mounted() {
        this.parsed = {
            categories: this.categories ? JSON.parse(this.categories) : null,
            menuCategories: {},
            articles: this.articles ? JSON.parse(this.articles) : null,
            featured: this.featured ? JSON.parse(this.featured) : null,
        };
        this.parsed.menuCategories = { ...this.parsed.categories };
        if (this.category_id) {
            this.parsed.categories = this.parsed.categories.filter(
                c => c.id === parseInt(this.category_id)
            );
            _;
        }
    },
};
</script>

<style scoped>
.accountsettings-bar {
    margin: 0 auto 0 0;
    color: #c3c3c3;
    background: #c3c3c3;
    height: 1px;
}
h4 {
    padding-left: 0.5rem;
}
.help-article {
    background-color: white;
    border-radius: 0.5rem;
    padding: 1rem;
}

.help-article >>> h1 {
    font-size: 1.35rem !important;
}
.help-article >>> h2 {
    font-size: 1.3rem !important;
}
.help-article >>> h3 {
    font-size: 1.25rem !important;
}
.help-article >>> h4 {
    font-size: 1.2rem !important;
}
.help-article >>> h5 {
    font-size: 1.15rem !important;
}
.help-article >>> h6 {
    font-size: 1.1rem !important;
}
</style>
